<form name="form" class="page-fix-accessibility-form page-fix-form-bold" #form="ngForm">
    <page-fix-form-wizard-container (dismiss)="dismiss.emit()"
                                    (close)="closeModal($event.pageFix)"
                                    [formValid]="!!form.valid && customValidation"
                                    [pageFixApplied]="!!pageFix"
                                    [pageFix]="pageFix">
        <page-fix-form-info-view [monType]="infoType"
                                 [monSelected]="!pageFix"
                                 [monOrder]="0">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/bold.png"
                     [attr.alt]="'Blink sample image' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>What is wrong with the &lt;b&gt; (bold) element?</h2>
                <p translate>
                    A &lt;b&gt; tag is often used in HTML to highlight text in bold thickness.
                    It can be hard for screen readers to understand the context of bold tags, however, as the latter can play multiple roles.
                    That is why it makes more sense to use the straightforward tag &lt;strong&gt; instead.
                </p>
                <h3 translate>And how are we going to fix it?</h3>
                <p translate>
                    This fix is actually pretty simple.
                    Acquia Web Governance will replace all the bold tags it finds on your website with strong tags instead.
                    That way there shouldn't be any problem for screen readers understanding your highlighted text.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
        <page-fix-form-bold-options [monPageFix]="pageFix"
                                    [monPageFixId]="pageFixId"
                                    [monPageFixSelector]="pageFixSelector"
                                    [monType]="optionsType"
                                    [monSelected]="!!pageFix"
                                    [monOrder]="1">
        </page-fix-form-bold-options>
        <page-fix-form-info-view [monType]="testingType"
                                 [monOrder]="2">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/bold-test.png"
                     [attr.alt]="'Blink testing sample image' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Potential problems that can arise</h2>
                <p translate>
                    Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:
                </p>

                <ul class="list-blue-disc">
                    <li><strong>Design of &lt;b&gt; tag</strong>: There might be some existing design for the bold tag in CSS.</li>
                    <li><strong>Design of &lt;strong&gt; tag</strong>: There might be some existing design for the strong tag in CSS.</li>
                </ul>
                <p class="mb-4" translate>
                    Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.
                </p>
                <h3 translate>What to do when things look wrong?</h3>
                <p translate>
                    The solution will most likely lie in CSS. Try to find the above mentioned tags in your CSS file and see what style they have attached to them.
                    If you wish to keep the old design for &lt;b&gt; tags just copy its attributes to the &lt;strong&gt; tag (or create a new one, if it doesn't yet exist).
                    A less common reason for wrong appearances could lie in the HTML code itself - if a &lt;b&gt; tag had some styling attached to it directly, this was most likely overwritten when it was replaced with &lt;strong&gt;.
                </p>
                <p translate>
                    <strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)
                </p>
                <pre>
                    strong {{ '{' }}
                        color: red;
                    {{ '}' }}
                </pre>
            </txt-slot>
        </page-fix-form-info-view>
    </page-fix-form-wizard-container>
</form>
